import styled, { css } from 'styled-components'
import { Form, Row, Button, Container } from 'react-bootstrap'
import colorConfig from '../../colorConfig'
import { BfButtonBlue } from '../styledForm/styledBlueForm';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Heading = styled.h3`
  margin-top: 6px;
  margin-bottom: 6px;
  font-weight: 600;
  font-family: "RM Neue", "sans-serif";    
`;

export const SubText = styled.p`
  margin-bottom: 12px;
  color: ${colorConfig.tabellrad_tekst} !important;
  font-weight: 400;
  font-size: 20px;
  font-family: "RM Neue", "sans-serif";    
`;

  export const Circle = styled.button`    
  background: ${props => props.primary || "white"};
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid black;
`;

export const FormRowItem = styled.div`
  min-width: 200px;
  max-width: 400px;
  padding-top: 10px;
`;

export const BfRowFormTransition = styled.div`
  // background-color: ${colorConfig.tabell_lysGul};
  color: black;
  border-bottom: 0;
  border: 0 solid black;
  font-family: "RM Neue", "sans-serif";
  font-size: 20px !important;

  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) =>
    props.visible ? "translateY(0)" : "translateY(-20px)"};
  transition: opacity 0.5s ease, transform 0.5s ease;
`;

export const ScoreGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5rem;
  ${props => props.customStyle}
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const ScorePairContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ScoreTitle = styled.span`
  font-weight: bold;
`;

export const ScoreValue = styled.span`
  font-size: 3.5rem;
`;

export const InfoGroupContainer = styled.div`
  flex: 1 1 0;
  box-sizing: border-box;
  border-radius: 4px;
  padding-top: 2rem;
`;

export const InfoGroupHeader = styled.h3`
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #ccc;
  padding-bottom: 0.25rem;
  font-size: 1.5rem;
`;

export const FieldContainer = styled.div`
  margin-bottom: 1rem;
`;

export const FieldTitle = styled.div`
  font-weight: 400;
  margin-bottom: 0.25rem;
`;

export const FieldValue = styled.div`
  font-weight: bold;
  margin-bottom: 0.25rem;
`;

export const StyledExpandableInfoGroupsContainer = styled.div`
  display: grid;
  gap: 4rem;
  padding-top: 2rem;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
`;

export const StyledExpandableInfoGroup = styled.div`
  flex: 1 1 0;
  border-radius: 4px;
  margin-bottom: 4rem;
  padding-top: 1rem;
`;

export const StyledExpandableInfoGroupHeader = styled.h3`
  border-bottom: 1px solid #ccc;
  padding-bottom: 0.25rem;
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
`;

export const StyledExpandableSubSectionContainer = styled.div`
  margin-bottom: 1rem;
`;

export const StyledSubSectionContent = styled.div`
  padding-left: 2.3rem;
  margin-top: 3rem;
  margin-bottom: -2rem;
`;

export const CollapsibleButton = styled.button`
  position: relative;
  display: inline-block;
  cursor: pointer;
  outline: none;
  border: 0;
  text-decoration: none;
  background: transparent;
  padding: 0;
  font-size: inherit;
  font-family: "RM Neue", "sans-serif";
  width: 11rem;
  height: auto;
  padding-top: 10px;

   .icon {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: ${({ isCollapsed }) => (isCollapsed ? '20px 0 0 0' : '26px 0 0 0')};
    left: 1.5rem;
    width: 1rem;
    height: 0.125rem;
    background: ${({ isCollapsed }) => (isCollapsed ? 'transparent' : 'transparent')};
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(90deg)' : 'rotate(-90deg)'};
  }
  .icon.arrow::before {
    content: "";
    position: absolute;
    top: -0.25rem;
    right: 0;
    width: 0.625rem;
    height: 0.125rem;
    background: #000;
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(45deg)' : 'rotate(-135deg)'};
    transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  .icon.arrow::after {
    content: "";
    position: absolute;
    bottom: -0.25rem;
    right: 0;
    width: 0.625rem;
    height: 0.125rem;
    background: #000;
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(-45deg)' : 'rotate(135deg)'};
    transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  .button-text {
    position: relative;
    color: #000;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    font-size: 1.3rem;
    margin: 0;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #000;
    transition: width 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  &:hover .icon {
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(90deg) translate(0.2rem, 0)' : 'rotate(-90deg) translate(0.3rem, 0)'};
    background: #000;
  }

  &:hover::after {
    width: 100%;
  }´
`;

export const CollapsButtonExpandSection = styled.button`
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  outline: none;
  border: 0;
  background: transparent;
  font-size: inherit;
  font-family: "RM Neue", sans-serif;
  padding: 12px 12px 0 12px;
  position: absolute;

  .icon {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: ${({ isCollapsed }) => (isCollapsed ? '20px 0 0 0' : '26px 0 0 0')};
    left: 0.3rem;
    width: 1rem;
    height: 0.125rem;
    background: ${({ isCollapsed }) => (isCollapsed ? 'transparent' : 'transparent')};
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(90deg)' : 'rotate(-90deg)'};
  }
  .icon.arrow::before {
    content: "";
    position: absolute;
    top: -0.25rem;
    right: 0;
    width: 0.625rem;
    height: 0.125rem;
    background: #000;
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(45deg)' : 'rotate(-135deg)'};
    transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  .icon.arrow::after {
    content: "";
    position: absolute;
    bottom: -0.25rem;
    right: 0;
    width: 0.625rem;
    height: 0.125rem;
    background: #000;
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(-45deg)' : 'rotate(135deg)'};
    transition: transform 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  .button-text {
    position: relative;
    color: #000;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    font-size: 1.4rem;
    left: 1.5rem;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #000;
    transition: width 0.45s cubic-bezier(0.65, 0, 0.076, 1);
  }

  &:hover .icon {
    transform: ${({ isCollapsed }) =>
      isCollapsed ? 'rotate(90deg) translate(0.2rem, 0)' : 'rotate(-90deg) translate(0.3rem, 0)'};
    background: #000;
  }

  &:hover::after {
    width: 110%;
  }´
`;

export const DownloadAndScoreRow = styled.div`
  display: flex;
  justify-content: start;
  gap: 5rem;
  margin-top: 2rem;
`;

export const FlexContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
`

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch; 
`;

export const StyledTable = styled.table`
  display: table;
  flex: 3;
  width: auto;
  table-layout: auto;
  font-family: 'Fellix', sans-serif;
  border: 2px solid #ddd;
  border-radius: 4px;
  border-collapse: separate;
  border-spacing: 0;
  padding: 6px 20px 20px 20px;
  background-color: white;
`

export const THead = styled.thead`
  & > caption {
    font-size: 20px;
    font-weight: 600;
    color: black;
  }`

export const TBody = styled.tbody``

export const Th = styled.th`
  white-space: nowrap;
  font-weight: bold;
  font-size: 16px;
  padding: 8px 12px;
  text-align: left;
  border-bottom: 2px solid #ddd;
  background-color: white;

  &:first-child { width: 40%; }
  &:nth-child(2) { width: 20%; text-align: right; },
  &:nth-child(3) { width: 20%; text-align: right; },
  &:nth-child(4) { width: 20%; text-align: right; }
`

export const Td = styled.td`
  white-space: nowrap;
  font-size: 16px;
  padding: 2px 12px;
  background-color: white;

  &:first-child { width: 40%; font-weight: normal; }
  &:nth-child(2) { width: 20%; font-weight: bold; text-align: right; },
  &:nth-child(3) { width: 20%; font-weight: bold; text-align: right; }
  &:nth-child(4) { width: 20%; font-weight: bold; text-align: right; }
`


export const SectionContainer = styled.div`
  margin-bottom: 24px;
  border: 2px solid #ddd;
  width: ${props => props.reduceWidth ? '25%' : '40%'};
  box-sizing: border-box;
  font-family: 'Fellix', sans-serif;
  padding-bottom: 20px;
  background-color: white;
`

export const SectionContainerTwo = styled.div`
  margin-bottom: 24px;
  border: 2px solid #ddd;
  box-sizing: border-box;
  font-family: 'Fellix', sans-serif;
  padding-bottom: 20px;
  background-color: white;
  flex: 1;
  min-width: 0; 
`

export const SectionContainerThree = styled.div`
  margin-bottom: 24px;
  border: 2px solid #ddd;
  flex: 1;
  min-width: 0; 
  box-sizing: border-box;
  font-family: 'Fellix', sans-serif;
  padding-bottom: 20px;
  background-color: white;
`

export const TitleSection = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  margin: 0;
  padding: 8px 12px;
  font-weight: 600;
  font-family: 'Fellix', sans-serif;
`

export const RegnskapTitle = styled.h3`
  font-size: 20px;
  margin: 0;
  padding: 8px 0;
  font-weight: 600;
  font-family: 'Fellix', sans-serif;
`

export const ExtraValue = styled.span`
  font-size: 20px;
  font-weight: normal;
  font-family: 'Fellix', sans-serif;
  font-size: 30px;
  margin: 0;
  padding-right: 12px;
  font-weight: 600;
  font-family: 'Fellix', sans-serif;
`

export const SectionTable = styled.table`
  width: 80%;
  border-collapse: collapse;
  border-spacing: 0 ${props => props.rowGap}px;
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  ${({ addGapAfter }) => addGapAfter && `
    td { 
      padding-bottom: 20px; 
    }
    th { 
      padding-bottom: 20px; 
    }
  `}`

export const LabelCell = styled.th`
  text-align: left;
  font-size: 16px;
  padding: 2px 12px;
  font-weight: normal;
  font-family: 'Fellix', sans-serif;
  vertical-align: top;
`

export const ValueCell = styled.td`
  text-align: left;
  font-size: 16px;
  padding: 2px 12px;
  font-weight: bold;
  font-family: 'Fellix', sans-serif;
  vertical-align: top;
`

export const GroupSubtitleRow = styled.tr``

export const GroupSubtitleCell = styled.th`
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 12px;
`

export const TotalLabelCell = styled(LabelCell)`
  font-weight: bold;
`
export const TotalValueCell = styled(ValueCell)``

export const HeaderRow = styled.thead`
  border-bottom: 2px solid #ddd;
`;

export const TableHeaderCell = styled.th`
  white-space: nowrap;
  font-weight: bold;
  font-size: 16px;
  padding: 8px 12px;
  text-align: left;
  border-bottom: 2px solid #ddd;

  &:first-child { width: 40%; }
  &:nth-child(2) { width: 20%; },
  &:nth-child(3) { width: 20%; },
  &:nth-child(4) { width: 20%; }
`;

export const TableBorder = styled.div`
  border: 2px solid #ddd;
  border-radius: 4px;
  border-collapse: separate;
  border-spacing: 0;
  padding: 0 12px 0 12px;
  margin: 20px 0 20px 0;
`;

export const TitleSectionTables = styled.h3`
  font-size: 20px;
  margin: 0;
  padding-top: 12px;
  font-weight: 600;
  font-family: 'Fellix', sans-serif;
`;

export const KredittvurderingForm = styled(Row)`
    // background-color: ${colorConfig.tabell_lysGul};  
    background-color: white;
    color: black;
    border-bottom: 0px;  
    padding: 10px 10px 0px 10px;      
    border: 0px solid black;
    font-family: "RM Neue", "sans-serif";
    font-size: 16px;
`

export const KredittvurderingTd = styled.td`
    tbody tr:nth-child(even) & {
        background-color: white;
    }
    tbody tr:nth-child(odd) & {
        background-color: #f1f1f1;
    }
`;

export const StyledKvTable = styled.table`   
  font-size: 16px;
  width: 100%;
  background-color: ${colorConfig.lys_gul}; 
  
  @media print {    
      table { font-size: 80%; }
  }

  tr:hover {
    cursor: default;

  }
  tr:nth-child(odd) { 
    background-color: ${colorConfig.taballrad_mork};  
    color: ${colorConfig.tabellrad_tekst} !important;
    @media print {
      * { 
          color: black;
          background-color: white;  
          line-height: 15px !important;
          font-size: 12px;
          padding: 0px 0px 0px 0px !important;
          font-family: 'Roboto', sans-serif;    
        }
      }    
      &:hover {
        color: black;
        background-color: ${colorConfig.button_bg};
        -webkit-transition: background-color .5s ease-out;
        -moz-transition: background-color .5s ease-out;
        -o-transition: background-color .5s ease-out;
        transition: background-color .5s ease-out;
        transition-delay:0.1s;
      }
  }
  tr:nth-child(even) {       
    background-color: ${colorConfig.tabell_lysGul}; 
    color: ${colorConfig.tabellrad_tekst} !important;
    @media print {
      * { 
          color: black;
          background-color: white;  
          line-height: 15px !important;
          font-size: 12px;
          padding: 0px 0px 0px 0px !important;
          font-family: 'Roboto', sans-serif;          
        }
      }
    &:hover {
        color: black;
        background-color: Tan;
        -webkit-transition: background-color .5s ease-out;
        -moz-transition: background-color .5s ease-out;
        -o-transition: background-color .5s ease-out;
        transition: background-color .5s ease-out;
        transition-delay:0.1s;
      }       
  }
  th {    
    white-space: nowrap;
    line-height: 24px;  
    padding: 12px 10px 12px 10px; 
    font-family: "RM Neue", "sans-serif";   
    font-weight: bold;
    font-size: 16px;   
    background-color: ${colorConfig.tabell_lysGul};
    color: ${colorConfig.header_tekst}; 
    
  }
  td {
    padding: 12px 10px 8px 10px; 
    font-family: "RM Neue", "sans-serif";    
    font-weight: normal;
    font-size: 16px;
    word-break: normal;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    vertical-align: top;  
    color: ${colorConfig.header_tekst}; 
  }
  td:hover {
    cursor: default;
  }  
`

export const KredittvurderingRowForm = styled(Row)`
  background-color: #fff;
  color: #111;
  padding: 10px 30px 0 30px;
  font-family: "RM Neue", "sans-serif"; 
  font-size: 20px !important;

  ${({ $bare }) =>
    $bare
      ? css`
          border: none;
          border-radius: 0;
          &:hover { border: none; }
          &:focus-within { border: none; box-shadow: none; }
        `
      : css`
          border: 1px solid rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          &:hover { border-color: rgba(0, 0, 0, 0.25); }
          &:focus-within {
            border-color: rgba(0, 0, 0, 0.35);
            box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);
          }
        `}
`;

export const StyledKredittvurderingTable = styled.table`   
  font-size: 20px;
  width: 100%;
  background-color: white; 
  
  @media print {    
      table { font-size: 80%; }
  }

  tr:hover {
    //opacity: 0.5;
    cursor: default;

  }
    
  tr:nth-child(odd) { 
    background-color: #f1f1f1;
    color: ${colorConfig.tabellrad_tekst} !important;
    @media print {
      * { 
          color: black;
          background-color: white;  
          line-height: 15px !important;
          font-size: 12px;
          padding: 0px 0px 0px 0px !important;
          font-family: 'Roboto', sans-serif;    
        }
      }    
      &:hover {
        color: black;
        background-color: lightgray;
        -webkit-transition: background-color .5s ease-out;
        -moz-transition: background-color .5s ease-out;
        -o-transition: background-color .5s ease-out;
        transition: background-color .5s ease-out;
        transition-delay:0.1s;
      }
  }
  tr:nth-child(even) {       
    background-color: white;
    color: ${colorConfig.tabellrad_tekst} !important;
    @media print {
      * { 
          color: black;
          background-color: white;  
          line-height: 15px !important;
          font-size: 12px;
          padding: 0px 0px 0px 0px !important;
          font-family: 'Roboto', sans-serif;          
        }
      }
    &:hover {
        color: black;
        background-color: lightgray;
        -webkit-transition: background-color .5s ease-out;
        -moz-transition: background-color .5s ease-out;
        -o-transition: background-color .5s ease-out;
        transition: background-color .5s ease-out;
        transition-delay:0.1s;
      }       
  }
  th {    
    white-space: nowrap;
    line-height: 38px;  
    padding: 5px 10px 20px 10px; 
    font-family: "RM Neue", "sans-serif";   
    font-weight:500;
    font-size: 20px;   
    background-color: ${colorConfig.tabell_lysGul};
    color: ${colorConfig.header_tekst}; 
    
  }
  td {
    padding: 12px 10px 8px 10px; 
    font-family: "RM Neue", "sans-serif";    
    font-weight: 400;
    word-break: normal;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    vertical-align: top;  
  }
  td:hover {
    cursor: default;
  }  
`

export const StyledImage = styled.img`
    max-width: 200px;
    height: auto;
    object-fit: contain;
`;

export const HeaderBar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 8px 16px;
`;

export const TitleBlock = styled.div`
  display: grid;
  gap: 0px;
  justify-items: start;
`;

export const Logo = styled(StyledImage)`
  justify-self: end;
  max-width: 80px;
  height: auto;
  object-fit: contain;
`;

export const Divider = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0,0,0,.9);
  margin: 0 0 16x;
`;

export const Controls = styled.div`
  display: grid;
  row-gap: 0px;
  width: min(100%, 600px);
  margin: 0 auto;
  justify-items: start;
`;

export const RadioRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-width: 0;
  margin-top: 8px;
  margin-bottom: -16px;
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 480px) auto;
  gap: 8px;
  align-items: center;
  justify-self: start;
  min-width: 0;

  margin-top: 0px;
  margin-bottom: 24px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    justify-items: stretch;
    row-gap: 8px;
    margin-top: 0;
  }
`;


export const InputWrap = styled.div`
  min-width: 0;
  > * { width: 100%; }
`;

export const CTAButton = styled(BfButtonBlue)`
  align-self: start;
  flex-shrink: 0;
  margin-top: 3px;
`;
